import { Space } from 'component/Space'
import { Switch } from 'component/Switch/Switch'
import { Tooltip } from 'component/Tooltip/Tooltip'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'

export const CombineSwitch = observer(() => {
  const demo = useDemo()
  const combine = demo.form.combine

  const onChange = useLatestCallback((value: boolean) => {
    demo.form.combine = value || null
    demo.form.refresh()
  })

  return <Space gap={6}>
    <Typo size={11} one medium upper>{i18n('Combo')}</Typo>
    <Tooltip tooltip={i18n('ComboTooltip')}>
      <Icon size={16} name="info" secondary />
    </Tooltip>
    <Switch checked={!!combine} onChange={onChange} />
  </Space>
})
